import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { CircularProgress } from "@material-ui/core";
import {UserContext} from "../providers/UserProvider";
import {auth} from "../services/firebase";
import {GlobalContext} from "../providers/GlobalProvider";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import LockIcon from '@material-ui/icons/Lock';
import AddAdmin from "./AddAdmin";
import SubmissionsProvider from "../providers/SubmissionsProvider";
import Submissions from "./Submissions";
import SubmissionStats from "./SubmissionStats";

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
    },
    fixedHeight: {
        height: 170,
    },
    loader: {
        marginTop: theme.spacing(4),
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    locked: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(5),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
}));

export default function Admin() {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const userState = useContext(UserContext);
    const globalState = useContext(GlobalContext);
    if (!userState.user || !globalState.data) {
        return (
            <Container maxWidth="lg" className={classes.container}>
                <Grid container spacing={3} justify={"center"}>
                    <CircularProgress />
                </Grid>
            </Container>
        );
    } else {
        let authEmail = auth.currentUser.email;
        let isAdmin = authEmail in globalState.data.admins;
        if (!isAdmin) {
            return (
                <Container component="main" maxWidth="xs">
                    <div className={classes.locked}>
                        <Avatar className={classes.avatar}>
                            <LockIcon />
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            Restricted
                        </Typography>
                        <Typography color="textSecondary">
                            Sorry, this page is only for admins!
                        </Typography>
                    </div>
                </Container>
            )
        }
        return (
            <SubmissionsProvider>
            <Container maxWidth="lg" className={classes.container}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6} lg={6}>
                        <Paper className={fixedHeightPaper}>
                            <AddAdmin/>
                        </Paper>
                    </Grid>
                    {/* Recent Score */}
                    <Grid item xs={12} md={6} lg={6}>
                        <Paper className={fixedHeightPaper}>
                            <SubmissionStats/>
                        </Paper>
                    </Grid>
                    {/* Recent SolvedChallenges */}
                    <Grid item xs={12}>
                        <Paper className={classes.paper}>
                            <Submissions/>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
            </SubmissionsProvider>
        );
    }
}
